import { supabase } from '../client'
import { logSupabaseError } from './logSupabaseError'

/** Eine eigene Cloud-Zeile, gefunden über ihre `local_id` — gelöschte eingeschlossen. */
export interface CloudRowRef {
  cloudId: string
  deleted: boolean
}

/** Dexie-Tabelle → Cloud-Tabelle: `canvasNotes` → `canvas_notes`. */
export const cloudTableOf = (dexieTable: string) => dexieTable.replace(/[A-Z]/g, c => `_${c.toLowerCase()}`)

const CHUNK = 200

/**
 * Die EIGENEN Cloud-Zeilen mit diesen `local_id`s, gelöschte eingeschlossen (ADR 0035): Ein Backup
 * kennt eine Zeile, die beim Erstellen noch nicht hochgeladen war, nur unter ihrer lokalen Kennung.
 * `null`, wenn die Abfrage scheitert — der Aufrufer kann dann nicht sicher abgleichen.
 */
export async function findOwnCloudRowsByLocalIds(table: string, localIds: readonly string[], userId: string): Promise<Map<string, CloudRowRef> | null> {
  const found = new Map<string, CloudRowRef>()
  if (!supabase || localIds.length === 0) return found
  try {
    for (let i = 0; i < localIds.length; i += CHUNK) {
      const { data, error } = await supabase
        .from(table)
        .select('id, local_id, deleted_at')
        .eq('user_id', userId)
        .in('local_id', localIds.slice(i, i + CHUNK))
      if (error) {
        logSupabaseError(`Find ${table} by local_id error`, error)
        return null
      }
      for (const row of (data ?? []) as Array<{ id: string; local_id: string | null; deleted_at: string | null }>) {
        if (row.local_id) found.set(row.local_id, { cloudId: row.id, deleted: row.deleted_at !== null })
      }
    }
    return found
  } catch (error) {
    logSupabaseError(`Find ${table} by local_id error`, error)
    return null
  }
}

/** Wie {@link findOwnCloudRowsByLocalIds} für eine Zeile; `null`, wenn es keine gibt oder die Abfrage scheitert. */
export async function findOwnCloudRowByLocalId(table: string, localId: string, userId: string): Promise<CloudRowRef | null> {
  return (await findOwnCloudRowsByLocalIds(table, [localId], userId))?.get(localId) ?? null
}
